import React from "react";
import { InvestorMarker } from "../api/transformers/marker";
import { CircularProgress, Typography, TypographyProps } from "@mui/material";

type MarkerDisplayProps = {
  marker?: InvestorMarker;
  placeholder?: string;
  loading: boolean;
} & TypographyProps;

const MarkerDisplay: React.FC<MarkerDisplayProps> = ({
  marker,
  loading,
  placeholder,
  ...props
}) => {
  const extraSx = props.sx || {};
  return (
    <Typography
      sx={{ minWidth: "60px", display: "inline-block", ...extraSx }}
      {...props}
    >
      {loading ? (
        <CircularProgress size="1rem" />
      ) : (
        marker?.description || placeholder || "None"
      )}
    </Typography>
  );
};

export default MarkerDisplay;
